<template>
  <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.3101 0.31014C10.6911 -0.0708596 11.3089 -0.0708596 11.6899 0.31014C12.0709 0.691139 12.0709 1.30886 11.6899 1.68986L10.3101 0.31014ZM1 11L0.31014 11.6899C-0.0708596 11.3089 -0.0708596 10.6911 0.31014 10.3101L1 11ZM11.6899 20.3101C12.0709 20.6911 12.0709 21.3089 11.6899 21.6899C11.3089 22.0709 10.6911 22.0709 10.3101 21.6899L11.6899 20.3101ZM11.6899 1.68986L1.68986 11.6899L0.31014 10.3101L10.3101 0.31014L11.6899 1.68986ZM1.68986 10.3101L11.6899 20.3101L10.3101 21.6899L0.31014 11.6899L1.68986 10.3101Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    name: "PrevArrow",
    props: ['color']
  }
</script>

<style scoped>

</style>